import { render, staticRenderFns } from "./Crumb.vue?vue&type=template&id=0894e56c&scoped=true&"
import script from "./Crumb.vue?vue&type=script&lang=js&"
export * from "./Crumb.vue?vue&type=script&lang=js&"
import style0 from "./Crumb.vue?vue&type=style&index=0&id=0894e56c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0894e56c",
  null
  
)

export default component.exports